import {User} from "../../../../api/accessControl/User.ts";
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Shell from "../../../../components/specific/Shell.tsx";
import PartnerClientInsights from "../PartnerClientInsights.tsx";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";


export default function PartnerClientInsightsPage({currentUser}: { currentUser: User }) {
    const { businessId, name } = useParams<{ businessId: string; name: string }>();

    return (
        <Shell currentUser={currentUser}>
            <div className="flex items-center gap-4 mb-6">
                <Link 
                    to="/partner"
                    className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                >
                    <ArrowLeftIcon className="h-5 w-5 text-gray-500" />
                </Link>
                <h1 className="weight-600 text-3xl">Insights for {decodeURIComponent(name)}</h1>
            </div>
            <PartnerClientInsights currentUser={currentUser} businessId={businessId} />
        </Shell>
    )
}
